import React, { useContext, useCallback, FC } from 'react';
import styled from 'styled-components';
import { useTranslation } from '@blocs.i18n';
import Checkbox from '@minecraft.minusable-checkbox';
import { haveSameContents } from '@minecraft.utils';
import SelectableDropdownContext from '../SelectableSearchDropdownContext';

type Props = {
  allOptions: Record<string, any>[];
};

const CheckboxWrapper = styled.div`
  border-bottom: 1px solid ${(props): string => props.theme.form.borderColor};
  margin-bottom: 0.75rem;
  padding-left: 1rem;
  padding-top: 0.5rem;
`;

const SelectAll: FC<Props> = ({ allOptions }) => {
  const { t } = useTranslation();

  const { saveAsOption, options, setOptions } = useContext(SelectableDropdownContext);

  const allOptionsValues = allOptions.map((option) => (saveAsOption ? option : option.value));
  const isChecked = haveSameContents(options, allOptionsValues);

  const toggleSelectAllCheckbox = useCallback((): void => {
    setOptions(isChecked ? [] : [...allOptionsValues]);
  }, [isChecked, allOptionsValues, setOptions]);

  return (
    <CheckboxWrapper>
      <Checkbox
        isChecked={isChecked}
        data-qa-id="selectable-dropdown-option-select-all"
        onChange={toggleSelectAllCheckbox}
        label={t('common:label.selectAll')}
      />
    </CheckboxWrapper>
  );
};

export default SelectAll;
